export default __webpack_public_path__ + "static/5 Reasons Why Companies Should Consider-69d6aa5c81fd3a1becdc2fc87482e9b7.jpg";